const groupBy = <T>(items: T[], getKey: (item: T) => string): Map<string, T[]> => {
    const groups = new Map<string, T[]>();

    for (const item of items) {
        const key = getKey(item);
        const group = groups.get(key) ?? [];

        group.push(item);
        groups.set(key, group);
    }

    return groups;
};

export default groupBy;
